import React, { useRef } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

function IndiaVsInternationalPie({ chart_data }) {
  let data_labels = [];
  let datasets_data = [];

  const chart = useRef();

  if (!chart.current) {
    chart_data?.forEach((item) => {
      data_labels.push(item.name);
      datasets_data.push(item.total);
    });
  } else {
    chart.current = true;
  }

  const data = {
    labels: data_labels,
    datasets: [
      {
        data: datasets_data, // change dynamically
        backgroundColor: ["#4CAF50", "#FF9800"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => context.raw, // show only value
        },
      },
      legend: {
        position: "bottom",
        onClick: () => {}, // ❌ disable toggle on click
        labels: {
          usePointStyle: true, // ✅ enables custom icon
          pointStyle: "circle", // 🔵 icon shape (circle, rect, triangle etc.)
          padding: 20,
          font: {
            size: 12,
            weight: "bold",
          },
          generateLabels: (chart) => {
            const data = chart.data;
            return data.labels.map((label, i) => ({
              text: label,
              fillStyle: data.datasets[0].backgroundColor[i],
              strokeStyle: data.datasets[0].backgroundColor[i],
              lineWidth: 0,
              hidden: false,
              index: i,
              pointStyle: "circle", // 👈 custom icon per item
            }));
          },
        },
      },
    },
    animation: false, // ❌ remove animation completely
  };

  return (
    <div style={{ width: "250px", height: "250px", margin: "0 auto" }}>
      <Pie data={data} options={options} />
    </div>
  );
}

export default IndiaVsInternationalPie;
